import { useAssignInvoiceCriteriaVM } from "presentation/hook/AssignInvoiceCriteria/useAssignInvoiceCriteriaVM";
import { memo, useEffect, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
import AssignInvoiceCriteriaPanel from "./AssignInvoiceCriteriaPanel";

const AssignInvoiceCriteriaMaintenance: React.FC = () => {
    const assignInvoiceCriteriaVM = useAssignInvoiceCriteriaVM();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const initialScreen = async () => {
            try {
                setIsLoading(true);
                const results = await Promise.allSettled([
                    assignInvoiceCriteriaVM.loadDropdownOption(),
                ]);
                results.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    } else if (index === 1 && result.status === 'rejected') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        };

        initialScreen().then((data) => {
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });

    }, [assignInvoiceCriteriaVM]);

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={'main-comp-wrapper im-hide-side-form-draggable'}>
            <AssignInvoiceCriteriaPanel />
        </div>
    </>
}

export default memo(AssignInvoiceCriteriaMaintenance);